var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card-title"},[_vm._v("公告栏")]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"ann",domProps:{"innerHTML":_vm._s(_vm.ann.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }